import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5f3a754"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-view" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.src,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _createElementVNode("a", {
        target: "_blank",
        href: _ctx.href,
        class: "btn"
      }, _toDisplayString(_ctx.contactNumber), 9, _hoisted_5)
    ])
  ]))
}